module.exports = __webpack_public_path__ + "static/media/local.cd0ad10b.png";